import { useCustomerInvitationsQuery } from './useCustomerInvitationsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CancelInvitationMutationParams {
  id: string;
}

export const useCancelInvitationMutation = createMutationHook(
  'settings.customerPortal.cancelInvitation',
  (params: CancelInvitationMutationParams) => ({
    crmCustomerInvitationCancel: {
      __args: {
        id: params.id,
      },
      id: true,
      invitationStatus: true,
    },
  }),
  {
    invalidateQueries: [useCustomerInvitationsQuery],
  },
);
